import axios from 'axios';
import store from '@/store/index';
import router from '@/router';
import _ from 'underscore';
import Vue from 'vue';

let refreshingToken = false;
let subscribers = [];

function onAccessTokenFetched() {
    subscribers = subscribers.filter((callback) => callback());
}

function addSubscriber(callback) {
    subscribers.push(callback);
}

const API = axios.create({
    baseURL: `${process.env.VUE_APP_ROOT_API}/api/`,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
});

API.interceptors.request.use(
    function (config) {
        const token = localStorage.getItem('token');
        if (
            !!token &&
            config.baseURL + config.url !==
            process.env.VUE_APP_OAUTH_REFRESH_TOKEN_URL
        ) {
            config.headers.Authorization = `Bearer ${token}`;
        } else if (
            config.baseURL + config.url ===
            process.env.VUE_APP_OAUTH_REFRESH_TOKEN_URL ||
            config.baseURL + config.url ===
            process.env.VUE_APP_OAUTH_TOKEN_URL
        ) {
            delete config.headers.Authorization;
        }
        return config;
    },
    function (err) {
        console.error('API request error', err);
        if (process.env.NODE_ENV !== 'production') {
            Vue.$toast.error(err.response, {
                timeout: 2000,
            });
        }
        return Promise.reject(err);
    }
);

API.interceptors.response.use(
    function (response) {
        if (response.data.error) {
            store.dispatch('logout');
            router.push('/');
        }
        return response;
    },
    function (err) {
        const { config } = err;
        const originalRequest = config;
        let status;
        if (err.response) {
            status = err.response.status;
        }

        if (status === 401) {
            // console.log("config.url", err.response.config.url)
            if (config.url === process.env.VUE_APP_LOCAL_LOGIN_URL) {
                return Promise.reject(err.response);
            }
            if (
                err.response.config.url ===
                process.env.VUE_APP_OAUTH_REFRESH_TOKEN_URL
            ) {
                store.dispatch('logout');
                router.push('/');
                return Promise.reject(err.response);
            }
            if (config.url === process.env.VUE_APP_OAUTH_TOKEN_URL) {
                //console.log("snding error")
                //store.dispatch('logout');
                //router.push('/');
                return Promise.reject(err.response);
            }

            if (!refreshingToken) {
                refreshingToken = true;
                if (
                    err.response.config.url ==
                    process.env.VUE_APP_OAUTH_TOKEN_URL
                ) {
                    store.dispatch('logout');
                    router.push('/');
                } else {
                    refreshToken()
                        .then((e) => {
                            store.dispatch('refreshToken', e.data);
                            refreshingToken = false;
                            onAccessTokenFetched();
                        })
                        .catch((e) => {
                            store.dispatch('logout');
                            router.push('/');
                        });
                    const retryOriginalRequest = new Promise((resolve) => {
                        addSubscriber(() => {
                            resolve(API(originalRequest));
                        });
                    });
                    return retryOriginalRequest;
                }
            } else {
                const retryOriginalRequest = new Promise((resolve) => {
                    addSubscriber(() => {
                        resolve(API(originalRequest));
                    });
                });
                return retryOriginalRequest;
            }
        } else if (status === 400) {
            if (err.response.config.param) {
                if (
                    err.response.config.params.grant_type &&
                    err.response.config.params.grant_type == 'password'
                ) {
                    return err.response;
                }
            }
        } else if (status === 413) {
            return Promise.reject(`ENTITY_TOO_LARGE`);
        } else {
            if (process.env.NODE_ENV !== 'production') {
                Vue.$toast.error(err.message, {
                    timeout: 2000,
                });
            }
        }

        if (status === 403) {
            // router.push("/");
        }
        console.log('rejecting with status', status, 'in response interceptor');
        return Promise.reject(err.response);
    }
);

export const RootAPI = API;

export function logout() {
    // console.log('calling logout');
    API.get('auth/logout').then(() => store.dispatch('logout'));
}

export function login(params) {
    return API.post('auth/login', params);
}

export function validateToken({ idToken }) {
    return API.post('auth/token', {
        token: idToken,
    });
}

export function refreshToken() {
    // console.log('refreshing token');
    return API.post('auth/refresh', {
        refresh_token: localStorage.getItem('refresh_token'),
    });
}

export function fetchProfile() {
    return API.get('user/profile');
}
export function fetchItems(dataType, params) {
    return API.get(`V1/${dataType}`, {
        params,
    });
}
export function count(dataType) {
    return API.get(`V1/${dataType}/count`);
}
export function itemsCount(dataType) {
    return API.get(`V1/${dataType}/count/`);
}
export function fetchItem(dataType, id) {
    return API.get(`V1/${dataType}/${id}`);
}
export function createItem(dataType, params) {
    return API.post(`V1/${dataType}`, params);
}
export function deleteItem(dataType, id, params) {
    return API.delete(`V1/${dataType}/${id}`, params);
}
export function updateItem(dataType, id, params) {
    return API.put(`V1/${dataType}/${id}`, params);
}

export function fetchSchoolProjectsCount(params) {
    return API.get(`V1/project/mySchool/count`, {
        params,
    });
}
export function fetchEntityProjects(params) {
    return API.get(`V1/project/mySchool`, {
        params,
    });
}
export function fetchEntityProjectStats() {
    return API.get(`V1/entity/stats/project`);
}
export function fetchEntityGameStats() {
    return API.get(`V1/entity/stats/game`);
}
export function fetchEntityGeneralStats() {
    return API.get(`V1/entity/stats/general`);
}

export async function upload(field, files, config) {
    let axiosConfig = {
        ...{
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        },
        ...config,
    };
    let formData = new FormData();
    _.each(files, (element) => {
        formData.append(`${field}[]`, element);
    });
    return API.post('V1/upload/', formData, axiosConfig);
}

/*export function staticMap(longitude, latitude, zoomLevel) {
    return `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&markers=icon:${process.env.ROOT_PATH
        }/img/icons/poi.png|${latitude},${longitude}&zoom=${zoomLevel || 16
        }&size=600x400&format=png&style=feature:poi.business|visibility:off&key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY
        }`;
}*/

/*export function geocoder(text) {
    return axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            text
        )}&key=${process.env.VUE_APP_GOOGLE_MAPS_API_KEY}`
    );
    return API.get(
        `https://nominatim.openstreetmap.org/search?q=${text}&format=geojson`
      );
}*/

export function joinSchool(code) {
    return API.post(`V1/joinSchool/`, { code });
}

export function validateUser(_id) {
    return API.post(`V1/validate/`, { _id });
}

export function joinSession(shortCode) {
    return API.put(`V1/session/join`, { shortCode });
}
export function getSessionRanking(session) {
    return API.get(`V1/session/${session}/ranking`);
}
export function getSessionRankingStatistics(session) {
    return API.get(`V1/session/${session}/ranking/statistics`);
}

export function getUserRankingPosition(session) {
    return API.get(`V1/session/${session}/ranking/position`);
}

export function sendAnswer(session, answer) {
    return API.post(`V1/session/${session}/score`, answer);
}

export function resetSession(session) {
    return API.delete(`V1/session/${session}/ranking`);
}

export function importClasses(session, answer) {
    return API.get(`V1/group/import`);
}

export function assignCourseWork(session, courseId) {
    return API.post(`V1/session/${session}/assign`, {
        courseId,
    });
}
export function pauseSession(sessionId, payload) {
    return API.put(`V1/session/${sessionId}/pause`, payload);
}

export function continueSession(sessionId, payload) {
    return API.put(`V1/session/${sessionId}/continue`, payload);
}

export function stopSession(sessionId, payload) {
    return API.put(`V1/session/${sessionId}/stop`, payload);
}

export function getSessionShortCode(sessionId) {
    return API.get(`V1/session/${sessionId}/shortcode`);
}


// local users related

export function localLogin(payload) {
    return API.post('login_check', payload);
}

export function localFetchProfile() {
    return API.get(process.env.VUE_APP_OAUTH_PROFILE_URL);
}

export function fetchChanges(dataType, id, params) {
    return API.get(`V1/${dataType}/${id}/changes`, {
        params,
    });
}

export function IPLocation() {
    return API.get('http://ip-api.com/json');
}

export function getURLMetadata(link) {
    return axios.get(`${process.env.VUE_APP_LINK_PREVIEW}?link=${link}`);
}

export function register(payload) {
    return API.post('V1/user/register', payload);
}

export function checkUsername(payload) {
    return API.post('V1/user/register/check/username', payload);
}

export function checkEmail(payload) {
    return API.post('V1/user/register/check/email', payload);
}

export function activateUser(payload) {
    return API.post('V1/user/activate', payload);
}

export function checkAppListCode(payload) {
    return API.post('V1/user/check/code', payload);
}







export function addComment(dataType, id, payload) {
    return API.post(`V1/${dataType}/${id}/comment`, payload);
}
export function updateComment(dataType, id, payload) {
    return API.put(`V1/${dataType}/${id}/comment/${payload._id}`, payload);
}
export function deleteComment(dataType, id, commentId) {
    return API.delete(`V1/${dataType}/${id}/comment/${commentId}`);
}

export function fetchComments(dataType, id, params) {
    return API.get(`V1/${dataType}/${id}/comments`, {
        params,
    });
}

export function likeObject(id) {
    return API.put(`V1/object/${id}/like`, {});
}

export function likeProject(id) {
    return API.put(`V1/project/${id}/like`, {});
}

export function highlightProject(id) {
    return API.put(`V1/project/${id}/highlight`, {});
}

export function manageAppList(datatype, id) {
    return API.put(`V1/${datatype}/${id}/manageAppList`, {});
}

export function watchProject(id) {
    return API.post(`V1/project/${id}/watch`, {});
}
export function unwatchProject(id) {
    return API.delete(`V1/project/${id}/watch`, {});
}

export function likeProjectComment(id) {
    return API.put(`V1/project/${id}/comment/like`, {});
}

export function inviteToProject(id, data) {
    return API.put(`V1/project/${id}/invite`, data);
}

export function fetchSchoolMembers(params) {
    return API.get('V1/school/members', {
        params,
    });
}
export function inviteSchoolMembers(payload) {
    return API.post('V1/school/invite', payload);
}

export function fetchFeaturedProjects(id) {
    return API.get(`V1/project/featured`);
}

export function fetchHomeFeaturedProjects(id) {
    return API.get(`V1/project/home_featured`);
}

export function getSchoolStatistics() {
    return API.get('V1/school/statistics');
}

export function fetchPublicFolders() {
    return API.get(`V1/folder/public`);
}

export function addProjectToFolder(folder, payload) {
    return API.put(`V1/folder/${folder}/add`, payload);
}
export function removeProjectFromFolder(folder, payload) {
    return API.put(`V1/folder/${folder}/remove`, payload);
}

export function addPost(dataType, id, payload) {
    return API.post(`V1/${dataType}/${id}/post`, payload);
}

export function validatePost(id) {
    return API.put(`V1/post/${id}/validate`);
}

export function fetchCommunityFeed(id, payload) {
    return API.get(`V1/community/${id}/feed`, payload);
}

export function fetchPublicCommunities() {
    return API.get(`V1/community/public`);
}
export function fetchMyCommunities() {
    return API.get(`V1/community/mine`);
}

export function joinCommunity(community, accessCode) {
    return API.put(`V1/community/${community}/join`, { accessCode });
}

export function likePost(id) {
    return API.put(`V1/community/${id}/post/like`, {});
}

export function addCourse(dataType, id, payload) {
    return API.post(`V1/${dataType}/${id}/course`, payload);
}

export function addActivity(dataType, id, payload) {
    return API.post(`V1/${dataType}/${id}/activity`, payload);
}

function deleteRelated(dataType, id, childType, childId) {
    return API.delete(`V1/${dataType}/${id}/${childType}/${childId}`);
}

function updateRelated(dataType, id, childType, childId, data) {
    return API.put(`V1/${dataType}/${id}/${childType}/${childId}`, data);
}

export function updatePost(community, post) {
    return updateRelated('community', community, 'post', post._id, post);
}

export function deleteCommunityPost(community, post) {
    return deleteRelated('community', community, 'communityPost', post);
}

export function deleteActivity(community, activity) {
    return deleteRelated('community', community, 'communityActivity', activity);
}

export function updateActivity(dataType, id, data) {
    return API.put(`V1/${dataType}/${id}/activity/${data._id}`, data);
}

export function updateCourse(dataType, id, data) {
    return API.put(`V1/${dataType}/${id}/course/${data._id}`, data);
}

export function fetchCommunityRelatedObject(id, related, relatedId, payload) {
    return API.get(`V1/community/${id}/${related}/${relatedId}`, payload);
}

export function deleteCourse(community, course) {
    return deleteRelated('community', community, 'course', course);
}

export function addCommunityItem(itemType, id, payload) {
    return API.post(`V1/community/${id}/${itemType}`, payload);
}

export function updateCommunityItem(itemType, itemId, id, payload) {
    return API.put(`V1/community/${id}/${itemType}/${itemId}`, payload);
}

export function updateCommunity(id, payload) {
    return API.put(`V1/community/${id}`, payload);
}

export function updateCommunityPreferences(id, payload) {
    return API.put(`V1/community/${id}/preferences`, payload);
}

export function deleteActivityFolder(community, folder) {
    return deleteRelated(
        'community',
        community,
        'communityActivityFolder',
        folder
    );
}

export function removeSchoolMember(userId) {
    return API.delete(`V1/school/removeMember/${userId}`);
}

export function createCircle(community, payload) {
    return API.post(`V1/community/${community}/circle`, payload);
}

export function fetchCircleMessages(circle, before) {
    return API.get(`V1/circle/${circle}/messages?before=${before}`);
}

export function sendMessageToCircle(id, payload) {
    return API.post(`V1/circle/${id}/message`, payload);
}

export function joinCircle(id, payload) {
    return API.put(`V1/circle/${id}/join`, payload);
}
export function leaveCircle(id, payload) {
    return API.delete(`V1/circle/${id}/leave`, payload);
}

export function updateMessageFromCircle(payload) {
    return API.put(
        `V1/circle/${payload.circle}/message/${payload._id}`,
        payload
    );
}

export function deleteMessageFromCircle(payload) {
    return API.delete(
        `V1/circle/${payload.circle}/message/${payload._id}`,
        payload
    );
}

export function exitCircle(circle, payload) {
    return API.put(`V1/circle/${circle}/exit`, payload);
}

export function publishActivity(dataType, communityId, activityId) {
    return API.put(
        `V1/${dataType}/${communityId}/activity/${activityId}/publish`
    );
}

export function unpublishActivity(dataType, communityId, activityId) {
    return API.put(
        `V1/${dataType}/${communityId}/activity/${activityId}/unpublish`
    );
}

export function duplicateActivity(dataType, communityId, activity) {
    return API.post(
        `V1/${dataType}/${communityId}/activity/${activity._id}/duplicate`,
        activity
    );
}

export function deleteCircle(community, circle) {
    return deleteRelated('community', community, 'circle', circle);
}

export function exitFolder(folder, community) {
    return API.put(
        `V1/community/${community}/communityActivityFolder/${folder}/exit`
    );
}

export function exitFeed(message, community) {
    return API.put(`V1/community/${community}/communityPost/${message}/exit`);
}

export function createLink(id, data) {
    return API.post(`V1/community/${id}/addLink`, data);
}

export function removeLink(id, payload) {
    return API.delete(`V1/community/${id}/removeLink`, { data: payload });
}

export function updateLinksOrder(id, data) {
    return API.put(`V1/community/${id}/updateLinksOrder`, data);
}

export function updateCircleOrder(id, data) {
    return API.put(`V1/community/${id}/updateCircleOrder`, data);
}

export function fetchCommunityCalendarEvents(id) {
    return API.get(`V1/community/${id}/calendar`);
}

export function addCommunityCalendarEvent(id, payload) {
    return API.post(`V1/community/${id}/calendar`, payload);
}
export function updateCommunityCalendarEvent(id, payload) {
    return API.put(`V1/community/${id}/calendar`, payload);
}
export function deleteCommunityCalendarEvent(id, eventId) {
    return API.delete(`V1/community/${id}/calendar/${eventId}`);
}
export function updateUserProjectConfiguration(id, payload) {
    return API.put(`V1/project/${id}/userConfiguration`, payload);
}
export function fetchCommunityMetadata(id) {
    return API.get(`V1/community/${id}/metadata`);
}
export function fetchAvailiablesScenarios(environment) {
    return API.get(`V1/import/${environment}`);
}
export function fetchScenarioObjectsList(environment, scenarioId) {
    return API.get(`V1/import/${environment}/${scenarioId}`);
}
export function uploadImageFromUrl(environment, payload) {
    return API.post(`V1/import/${environment}/image`, payload);
}

export function importObject(environment, payload) {
    return API.post(`V1/import/${environment}/object`, payload);
}

export function fetchFeaturedInspirations() {
    return API.get(`V1/inspiration`);
}

export function linkObjects(payload) {
    return API.post(`V1/import/link_objects`, payload);
}

export function fetchItemSimplified(dataType, id) {
    return API.get(`V1/${dataType}/simplified/${id}`);
}

export function fetchItemsSimplified(dataType, params) {
    return API.get(`V1/${dataType}/simplified`, {
        params,
    });
}

export function fetchPublicProjects() {
    return API.get(`V1/project/public`);
}

export function duplicateProject(projectId) {
    return API.post(`V1/project/duplicate/${projectId}`);
}

export function duplicateObject(projectId, objectId) {
    return API.post(`V1/project/duplicate/${projectId}/${objectId}`);
}

export function reassignTriggers(projectId, payload) {
    return API.post(`V1/project/duplicate/${projectId}/triggers`, payload);
}

export function getUserDataForProjectInvite(payload) {
    return API.post(`V1/user/inviteToProject`, payload);
}

export function fetchAppContent() {
    return API.get(`V1/project/appContent`);
}

export function fetchMyProjectsInfo() {
    return API.get(`V1/project/mine/info`);
}

export function stripeUserPortal() {
    return API.get(`stripe/portal`);
}

export function updateMyProfile(payload) {
    return API.put(`V1/profile/me`, payload);
}

export function removeMyUser() {
    return API.delete(`V1/profile/me`);
}

export function requestPassword(payload) {
    return API.post(`V1/profile/password/request`, payload);
}

export function changePassword(payload) {
    return API.post(`V1/profile/password/change`, payload);
}

export function updateMyAppListCode(payload) {
    return API.put(`V1/profile/code/update`, payload);
}

export function updateUserEntityPermissions(payload) {
    return API.post('V1/school/userPerms', payload);
}

export function setActiveEntity(payload) {
    return API.put(`V1/profile/entity`, payload);
}

export function fetchEntityMembers(params) {
    return API.get('V1/school/users', {
        params,
    });
}
